var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editable-cell3"
  }, [_c("div", {
    staticClass: "editable-cell-input-wrapper"
  }, [_c("a-form-model-item", [_c("a-input-number", {
    class: {
      "has-error": _vm.err,
      alignRight: _vm.align == "right",
      alignLeft: _vm.align == "left"
    },
    staticStyle: {
      width: "100%",
      "text-align": "right"
    },
    attrs: {
      value: _vm.value,
      min: 0,
      max: 99999999
    },
    on: {
      change: _vm.handleChange,
      pressEnter: _vm.check
    }
  }), _vm.err ? _c("div", {
    staticClass: "err",
    staticStyle: {
      "line-height": "12px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.enterPlease")) + " ")]) : _vm._e()], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };